import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";

import { GrTransaction } from "react-icons/gr";

import AdminLivePcView from "./ViewMode/AdminLivePcView";
import AdminLiveMobileView from "./ViewMode/AdminLiveMobileView";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import MenuUi from "../../../helpers/MenuUi/MenuUi";

import { transactionAdminContext } from "../../../context/AdminContext/TransactionAdminContext/TransactionAdminContext";

const AdminLiveTransactions = () => {
  const {
    //* Live Orders Start
    setCounter,
    getLiveOrders,
    handleGetLiveOrders,
    handleChangeOrderType,
  } = useContext(transactionAdminContext);

  //* Fetch Data Start
  const handleInitial = () => {
    setCounter((prevCounter) => prevCounter + 1);
    handleGetLiveOrders();
  };

  useEffect(() => {
    handleInitial();
    const interval = setInterval(handleInitial, 5000);
    return () => clearInterval(interval);
  }, []);
  //* Fetch Data End

  return (
    <>
      <SiteTitle title="معاملات فعال" />
      <div className="mr-auto w-full h-screen">
        <div
          className="flex w-full h-full justify-center overflow-y-scroll 
          items-start bg-mainBackground relative"
        >
          {/* Menu */}
          <MenuUi className={"top-4"} />
          {/* Items */}
          {isEmpty(getLiveOrders) ? (
            <>
              <span
                className="w-full h-full absolute space-y-5
                left-0 right-0 text-slate-200 text-xl
                flex flex-col justify-center items-center"
              >
                <span>
                  <GrTransaction size={60} />
                </span>
                <p>سفارشی وجود ندارد</p>
              </span>
            </>
          ) : (
            <>
              {/* Pc View */}
              <span className="lg:flex hidden w-full">
                <AdminLivePcView
                  getLiveOrders={getLiveOrders}
                  handleChangeOrderType={handleChangeOrderType}
                />
              </span>

              {/* Mobile View */}
              <span className="lg:hidden none w-11/12">
                <AdminLiveMobileView
                  getLiveOrders={getLiveOrders}
                  handleChangeOrderType={handleChangeOrderType}
                />
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AdminLiveTransactions;
